import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Çeviri dosyaları
const resources = {
  tr: {
    translation: {
      lang: 'tr',
      // Navigation
      nav: {
        // Authenticated navigation
        dashboard: 'Gösterge Paneli',
        myPresences: 'Varlıklarım',
        create: 'Oluştur',
        settings: 'Ayarlar',
        help: 'Yardım',
        logout: 'Çıkış Yap',
        
        // Public navigation
        home: 'Ana Sayfa',
        technology: 'Teknoloji',
        features: 'Özellikler',
        pricing: 'Fiyatlandırma',
        ethics: 'Etik ve Yönetişim'
      },
      
      // Landing/Welcome Page
      landing: {
        welcome: 'RepresenX\'e Hoş Geldiniz',
        subtitle: 'Yapay zeka destekli dijital kimliğinizi oluşturun',
        getStarted: 'Başlayın',
        learnMore: 'Daha Fazla Bilgi',
        login: 'Giriş Yap',
        register: 'Kayıt Ol'
      },
      
      // Home Page
      home: {
        ethicsBadge: 'Simülasyon · Etik Olarak Yönetilen',
        tagline: 'Hafızadan Fazlası — Bir Varlık.',
        description: 'Değerlerinizi, sesinizi ve sizi tanımlayan özü yakalayan dijital bir varlık. Bir kopya değil — sizi gerçekten tanımlayan şeyle şekillenen bir yansıma.',
        disclaimer: 'RepresenX değerlere uyumlu bir simülasyondur. Gerçek kişi değildir.',
        createYourPresence: 'Varlığınızı Oluşturun',
        learnTechnology: 'Teknolojiyi Öğrenin',
        
        // Block 2 - Presence Engine
        presenceEngineTitle: 'Varlık Motoru',
        presenceEngineSubtitle: 'RepresenX, nasıl konuştuğunuzu, neye değer verdiğinizi ve kendinizi nasıl ifade ettiğinizi anlamak için tasarlanmış akıllı bir motor tarafından desteklenir — size özgün bir varlık yaratır.',
        voiceStyleTitle: 'Ses & Stil Simülasyonu',
        voiceStyleDesc: 'Tonunuzu, ritminizi ve ifade kalıplarınızı hassasiyetle yeniden oluşturur.',
        valueMappingTitle: 'Değer Haritalama',
        valueMappingDesc: 'Kişisel ilkeleriniz varlığınızın davranışına rehberlik eder.',
        behaviorTitle: 'Davranış Öğrenme',
        behaviorDesc: 'Siz geliştikçe gelişen tutarlı etkileşim kalıpları.',
        socialMediaImportTitle: 'Sosyal Medya İçe Aktarma',
        socialMediaImportDesc: 'Instagram, Twitter veya Facebook verilerinizi yükleyin, GPT-4 otomatik olarak hafızalar ve Q&A örnekleri oluştursun.',
        
        // Block 3 - Demo Preview
        presenceInActionTitle: 'Varlığınız Çalışırken',
        presenceInActionDesc: 'RepresenX\'in nasıl etkileşime girdiğini, yanıt verdiğini ve tonunuzu ve değerlerinizi nasıl yansıttığını deneyimleyin.',
        
        // Block 3.5 - Training & Learning
        trainingTitle: 'Varlığınızı Sürekli Geliştirin',
        trainingSubtitle: 'Dijital varlığınızı Q&A örnekleri, konuşma gözden geçirmeleri ve otomatik öğrenme ile eğitin ve zenginleştirin.',
        trainingModuleTitle: 'Eğitim Merkezi',
        trainingModuleDesc: 'Varlığınızı eğitmek için kapsamlı araçlar ve kontrol.',
        trainingFeature1: 'Q&A örnekleri ekleyin ve yönetin',
        trainingFeature2: 'Toplu veri yükleme ile hızlı eğitim',
        trainingFeature3: 'Eğitim metrikleri ve ilerleme takibi',
        autoLearningTitle: 'Otomatik Öğrenme',
        autoLearningDesc: 'GPT-4 konuşmalarınızı analiz eder ve yeni Q&A önerileri oluşturur.',
        autoLearningFeature1: 'Konuşmalardan otomatik Q&A çıkarma',
        autoLearningFeature2: 'Güven skorları ile akıllı öneriler',
        autoLearningFeature3: 'Onay/red ile kontrollü öğrenme',
        
        // Block 4 - Use Cases
        useCasesTitle: 'RepresenX Fark Yarattığı Yerler',
        legacyTitle: 'Miras Varlık',
        legacyDesc: 'Özünüzü sevdikleriniz için koruyun — zaman ve mesafeyi aşarak.',
        companionTitle: 'Kişisel Yapay Zeka Arkadaşı',
        companionDesc: 'Sizi derinden anlayan ve sizinle büyüyen bir yapay zeka.',
        professionalTitle: 'Profesyonel Kişilik',
        professionalDesc: 'Uzmanlığınızı ölçeklenebilir, tutarlı dijital bir kimlikle genişletin.',
        memoryTitle: 'Hafıza Koruma',
        memoryDesc: 'Anıları bağlantılı bir anlatıya dönüştürün.',
        
        // Block 5 - Ethics
        ethicsTitle: 'Etik Üzerine İnşa Edildi. Rıza ile Desteklendi.',
        ethicsSubtitle: 'RepresenX saygılı bir simülasyon olarak tasarlanmıştır — herhangi bir kişinin yerini alacak değil. Her varlık açık rıza ile oluşturulur, net sınırlarla sınırlandırılır ve katı gizlilik, güvenlik ve şeffaflık standartları altında işletilir.',
        consentTitle: 'Açık Rıza',
        consentDesc: 'Varlıklar yalnızca net, belgeli rıza ve gerektiğinde uygun yetkili kişilerin onayı ile oluşturulur ve kullanılır.',
        boundariesTitle: 'Net Sınırlar',
        boundariesDesc: 'Mali talimatlar, kimlik doğrulama, tıbbi veya yasal tavsiye ve siyasi ikna gibi yüksek riskli kullanım durumları tasarım gereği engellenmiştir.',
        transparencyTitle: 'Şeffaf Simülasyon',
        transparencyDesc: 'Her etkileşim, görünür sorumluluk reddi beyanları ve izlenebilir davranışlarla birlikte, bir simülasyonla konuştuğunuzu açıkça belirtir.',
        readEthicsPolicy: 'Tam Etik ve Yönetişim Politikasını Okuyun'
      },
      
      // Auth Pages
      auth: {
        login: 'Giriş Yap',
        register: 'Kayıt Ol',
        createAccount: 'Hesap Oluştur',
        name: 'İsim',
        email: 'E-posta',
        password: 'Şifre',
        confirmPassword: 'Şifreyi Onayla',
        loginButton: 'Giriş Yap',
        registerButton: 'Kayıt Ol',
        alreadyHaveAccount: 'Zaten hesabınız var mı?',
        dontHaveAccount: 'Hesabınız yok mu?',
        forgotPassword: 'Şifrenizi mi unuttunuz?',
        namePlaceholder: 'Adınızı girin',
        emailPlaceholder: 'E-posta adresinizi girin',
        passwordPlaceholder: 'Şifrenizi girin',
        confirmPasswordPlaceholder: 'Şifrenizi tekrar girin',
        // Toast messages
        loginSuccess: 'Hoş geldiniz!',
        loginSuccessDesc: 'Başarıyla giriş yapıldı.',
        loginFailed: 'Giriş Başarısız',
        invalidCredentials: 'E-posta veya şifre hatalı. Lütfen tekrar deneyin.',
        registerSuccess: 'Hesap Oluşturuldu!',
        registerSuccessDesc: 'RepresenX\'e hoş geldiniz.',
        registerFailed: 'Kayıt Başarısız',
        emailExists: 'Bu e-posta adresi zaten kullanılıyor.'
      },
      
      // Dashboard
      dashboard: {
        title: 'Gösterge Paneli',
        welcomeBack: 'Tekrar hoş geldiniz. Varlıklarınız, etkinlikleriniz ve kontrolleriniz tek yerde.',
        noPresences: 'Henüz Varlık Yok',
        noPresencesDesc: 'Başlamak için ilk dijital varlığınızı oluşturun.',
        selectPresence: 'Bir varlık seçin',
        
        // Metrics
        totalInteractions: 'Toplam Etkileşim',
        memoryNodes: 'Hafıza Düğümleri',
        activeConnections: 'Aktif Bağlantılar',
        accuracyScore: 'Doğruluk Skoru',
        
        // Tabs
        overview: 'Genel Bakış',
        memory: 'Hafıza',
        activity: 'Etkinlik',
        chat: 'Sohbet',
        
        // Activity Feed
        recentActivity: 'Son Etkinlik',
        noActivity: 'Henüz etkinlik yok',
        
        // Memory
        memoryGraph: 'Hafıza Grafiği',
        noMemories: 'Henüz anı eklenmedi',
        
        // Chat
        recentConversations: 'Son Konuşmalar',
        noConversations: 'Henüz konuşma yok',
        startChat: 'Sohbet Başlat',
        viewAll: 'Tümünü Görüntüle',
        
        // Actions
        managePresence: 'Varlığı Yönet',
        viewDetails: 'Detayları Görüntüle',
        exportData: 'Verileri Dışa Aktar'
      },
      
      // Presence Creation
      presenceCreation: {
        title: 'Varlık Oluştur',
        subtitle: 'Sizin gibi düşünen, konuşan ve önemseyen bir simülasyon oluşturmak için rehberli bir yolculuk.',
        pageTitle: 'Varlığınızı Oluşturun - Adım Adım',
        
        // Hero Bullets
        bullet1: 'Rıza, kapsam ve erişimi tanımlayın.',
        bullet2: 'Stil, değerler ve önemli anıları yakalayın.',
        bullet3: 'Etkinleştirmeden önce önizleyin ve ince ayar yapın.',
        disclaimer: 'Bu, yapay zeka destekli bir simülasyondur, gerçek kişi değildir. İstediğiniz zaman duraklatabilir veya silebilirsiniz.',
        
        // Progress
        stepOf: 'Adım',
        of: '/',
        complete: 'Tamamlandı',
        
        // Steps
        consentTitle: 'Rıza ve Kapsam',
        consentIcon: 'shield',
        consentDescription: 'Varlığınızı oluşturmadan önce izinleri, kullanım senaryolarını ve sınırları tanımlayın.',
        consentHelper: 'Bir varlık oluşturmadan önce, izinleri ve sınırları açıkça tanımlamamız gerekir.',
        
        voiceSamplesTitle: 'Ses Örnekleri',
        voiceSamplesDescription: 'Ton analizi için ses klipleri yükleyin veya kaydedin.',
        voiceSamplesPlaceholder: 'Ses özelliklerinizi tanımlayın veya ses örnekleri yükleyin...',
        voiceSamplesHelper: '30-120 saniyelik çeşitli konuşma, sistemin tonu ve tempoyu anlamasına yardımcı olur.',
        
        styleTitle: 'İletişim Stili',
        styleDescription: 'İletişim şeklinizi tanımlayın — sakin, esprili, doğrudan veya etkileyici.',
        stylePlaceholder: 'örn: sıcak, doğrudan, esprili, düşünceli',
        styleHelper: 'Anahtar kelimeler ton, tempo ve duygusal enerjiyi şekillendirmeye yardımcı olur.',
        
        valuesTitle: 'Temel Değerler',
        valuesDescription: 'Varlığınıza rehberlik eden inançları tanımlayın.',
        valuesPlaceholder: 'örn: empati, adalet, dürüstlük',
        valuesHelper: 'Bunlar, varlığın nasıl karar verdiğine rehberlik eder.',
        
        memoriesTitle: 'Hafıza Noktaları',
        memoriesDescription: 'Kimliğinizi tanımlayan önemli anları ekleyin.',
        memoriesPlaceholder: 'örn: "Lise mezuniyeti", "İlk evimiz"',
        memoriesHelper: 'Olayı 1-3 cümlede tanımlayın.',
        
        previewTitle: 'Varlığı Önizle',
        previewDescription: 'Varlığınızın örnek konuşmalarda nasıl davrandığını görün.',
        previewHelper: 'Varlığın verilerinizi ve stil ayarlarınızı kullanarak nasıl yanıt verdiğini gözden geçirin.',
        
        saveTitle: 'Kaydet ve Etkinleştir',
        saveDescription: 'Ayarları sonlandırın ve varlığınızı etkinleştirin.',
        saveHelper: 'Varlığı Dashboard\'dan istediğiniz zaman duraklatabilir veya silebilirsiniz.',
        
        // Step 0 - Consent
        consentNotice: 'Bir varlık oluşturmadan önce, hangi verilerin kullanılabileceğini, varlığa kimlerin erişebileceğini ve hangi amaçlar için etkinleştirilebileceğini açıkça tanımlamamız gerekir.',
        whoIsThisFor: 'Bu varlık kim için?',
        whoIsThisForDesc: 'Kendiniz için mi yoksa temsil etme yetkisine sahip olduğunuz biri için mi bir varlık oluşturduğunuzu seçin.',
        myself: 'Kendim',
        familyMember: 'Bir aile üyesi (yasal yetki ile)',
        
        // Buttons
        next: 'İleri',
        back: 'Geri',
        skipStep: 'Bu Adımı Atla',
        saveDraft: 'Taslağı Kaydet',
        finish: 'Bitir ve Etkinleştir',
        creating: 'Oluşturuluyor...',
        
        // Success Screen
        successTitle: 'Varlığınız hazır.',
        successMessage: 'Stili, anıları ve güvenlik ayarlarını istediğiniz zaman ayarlayabilirsiniz.',
        goToDashboard: 'Dashboard\'a Git',
        startUsing: 'Varlığı Kullanmaya Başla',
        autoRedirect: 'Otomatik olarak dashboard\'a yönlendiriliyorsunuz...',
        autoRedirectTime: '4 saniye içinde otomatik olarak dashboard\'a yönlendirileceksiniz...',
        
        // Validation Messages
        fixErrors: 'Devam etmeden önce lütfen hataları düzeltin',
        specifyUseCase: 'Lütfen en az bir izin verilen kullanım senaryosu belirtin.',
        approveDataType: 'En az bir veri türünü onaylamalısınız.',
        invalidEmails: 'Bir veya daha fazla e-posta adresi geçersiz.',
        confirmNotice: 'Simülasyon bildirimini onaylamalısınız.',
        describeStyle: 'Lütfen en az bir stil özelliğini tanımlayın.',
        includeValue: 'Lütfen en az bir temel değer ekleyin.',
        providePresenceName: 'Lütfen varlığınız için bir ad verin.',
        
        // Draft Save
        draftSaved: 'Taslak başarıyla kaydedildi',
        draftSavedDesc: 'Dashboard\'unuzdan daha sonra devam edebilirsiniz',
        
        // Error Messages
        createFailed: 'Varlık oluşturulamadı',
        tryAgain: 'Lütfen tekrar deneyin'
      },
      
      // Help
      help: {
        title: 'Nasıl',
        titleHighlight: 'Yardımcı Olabiliriz?',
        subtitle: 'Yanıtlar, kılavuzlar ve destek kaynaklarını bulun',
        searchPlaceholder: 'Yardım makaleleri, kılavuzlar veya konular arayın...',
        allTopics: 'Tüm Konular',
        gettingStarted: 'Başlarken',
        managingPresences: 'Varlık Yönetimi',
        ethicsSafety: 'Etik ve Güvenlik',
        technical: 'Teknik',
        readTime: 'dk okuma',
        noResults: 'Sonuç bulunamadı',
        tryDifferent: 'Farklı arama terimleri deneyin veya tüm konulara göz atın',
        needMoreHelp: 'Daha Fazla Yardıma mı İhtiyacınız Var?',
        contactSupport: 'Desteğe Ulaşın'
      },
      
      // Settings
      settings: {
        title: 'Ayarlar',
        subtitle: 'Hesap tercihlerinizi ve yapılandırmalarınızı yönetin',
        account: 'Hesap',
        security: 'Güvenlik',
        billing: 'Faturalandırma',
        notifications: 'Bildirimler',
        integrations: 'Entegrasyonlar',
        dataExport: 'Veri ve Dışa Aktarım'
      },
      
      // Presence Details
      presenceDetail: {
        // Overview
        loading: 'Yükleniyor...',
        simulation: 'Simülasyon',
        active: 'Aktif',
        paused: 'Duraklatılmış',
        pausePresence: 'Duraklat',
        activatePresence: 'Etkinleştir',
        settings: 'Ayarlar',
        
        // Metrics
        totalInteractions: 'Toplam Etkileşim',
        memoryNodes: 'Hafıza Düğümleri',
        avgResponseTime: 'Ort. Yanıt Süresi',
        accuracyScore: 'Doğruluk Skoru',
        
        // Quick Actions
        quickActions: 'Hızlı İşlemler',
        startChat: 'Sohbet Başlat',
        addMemory: 'Anı Ekle',
        editBehavior: 'Davranışı Düzenle',
        viewActivity: 'Etkinliği Görüntüle',
        
        // Recent Activity
        recentActivity: 'Son Etkinlik',
        noActivity: 'Henüz etkinlik yok',
        viewAllActivity: 'Tüm Etkinliği Görüntüle',
        
        // Errors
        notFound: 'Varlık bulunamadı',
        loadError: 'Varlık verileri yüklenemedi'
      },
      
      // Ethics Page
      ethics: {
        title: 'Etik ve Yönetişim',
        subtitle: 'İlkelerimiz',
        
        // Secondary Navigation
        principles: 'Temel İlkeler',
        consent: 'Rıza ve Haklar',
        privacy: 'Gizlilik ve Güvenlik',
        governance: 'Yönetişim Modeli',
        safety: 'Güvenlik Kontrolleri',
        viewDetailedPages: 'Detaylı sayfaları görüntüle →',
        
        // Main Title
        mainTitle: 'Etik Üzerine İnşa Edildi. Rıza ile Güçlendirildi.',
        mainSubtitle: 'RepresenX, saygılı, şeffaf ve kullanıcı güvenliğine odaklanarak inşa edilmiştir.',
        
        // Core Principles Box
        corePrinciplesTitle: 'Temel İlkeler',
        explicitConsent: 'Açık rıza ve net kapsam',
        simulationNotReplacement: 'Simülasyon, asla değiştirme değil',
        prohibitedHighRisk: 'Tasarım gereği yasaklanmış yüksek riskli kullanımlar',
        
        // Consent Section
        consentComesFirst: 'Rıza Her Şeyden Önce Gelir',
        consentDescription: 'RepresenX\'te açık, bilinçli rıza olmadan hiçbir varlık oluşturulmaz. Bir kişi hayattayken, hangi verilerin kullanılabileceğine, hangi amaçlarla ve ne kadar süreyle karar verir. Ölüm sonrası bağlamlarda, uygun yasal vasiler veya mirasçılar sürekli kullanımı onaylamalıdır.',
        consentRequirementsTitle: 'Rıza Gereksinimleri',
        documentedConsent: 'Belgelenmiş, geri alınabilir rıza',
        definedScope: 'Tanımlı kapsam: metin, ses, video, metadata',
        clearUsagePurposes: 'Net kullanım amaçları (örneğin sadece özel aile erişimi)',
        respectRights: 'Yerel "tanıtım hakkı" ve benzerlik yasalarına saygı',
        
        // Simulation Section
        simulationTitle: 'Bir Simülasyon — Kişinin Kendisi Değil',
        simulationDescription: 'RepresenX açıkça bir simülasyon olarak tasarlanmıştır, yaşayan bir kişinin yerine geçmez. Her arayüz, yapay zeka tarafından oluşturulan bir varlıkla etkileşimde bulunduğunuzu açıkça belirtir. Sistem asla gerçek bireyi iddia etmez.',
        alwaysVisibleNotice: 'Her Zaman Görünür Bildirim',
        simulationNotice: '"Bu, seçilmiş verilere dayanan yapay zeka destekli bir simülasyondur. Gerçek kişi değildir."',
        
        // Prohibited Uses
        prohibitedUsesTitle: 'Yasaklanmış Kullanımlar',
        prohibitedUsesDescription: 'RepresenX, yanlış temsil veya kötüye kullanım riskini en aza indirmek için belirli yüksek riskli kullanım durumlarını yasaklar.',
        identityFraud: 'Kimlik dolandırıcılığı veya kimliğe bürünme',
        politicalCampaigns: 'Politik kampanyalar veya kamuoyu manipülasyonu',
        financialAdvice: 'Mali tavsiye veya işlemler',
        medicalDiagnosis: 'Tıbbi teşhis veya tedavi tavsiyeleri',
        legalRepresentation: 'Yasal temsil veya sözleşme imzalama',
        
        // Privacy & Data
        privacyDataTitle: 'Gizlilik ve Veri Sahipliği',
        privacyDataDescription: 'Verileriniz sizindir. Her zaman. RepresenX, kullanıcıların neyin depolandığını, kim tarafından erişildiğini ve nasıl kullanıldığını kontrol etmesine olanak tanır.',
        dataOwnershipTitle: 'Veri Sahipliği',
        youOwnData: 'Tüm girdileri, hafızaları ve varlık verilerini siz sahiplenirsiniz',
        localFirstOption: 'İsteğe bağlı yerel öncelikli depolama',
        exportAnytime: 'İstediğiniz zaman dışa aktarın veya veri silme talebinde bulunun',
        noThirdParty: 'Açık izniniz olmadan üçüncü taraf paylaşımı yapılmaz',
        
        // Compliance
        complianceTitle: 'Uyumluluk',
        gdprCompliant: 'GDPR uyumlu (Avrupa)',
        ccpaCompliant: 'CCPA uyumlu (ABD)',
        kvkkCompliant: 'KVKK uyumlu (Türkiye)',
        transparentPolicies: 'Şeffaf veri politikaları ve kullanım koşulları',
        
        // Prohibited Uses Section
        prohibitedUsesTitle: 'RepresenX Ne İçin Kullanılmayacak',
        prohibitedUsesDesc: 'Bazı kullanımlar, savunduğumuz saygınlık ve güvenlik standartlarıyla uyumlu değildir. Bunlar hem politika hem de teknik güvenlik önlemleriyle engellenir.',
        noIdentityFraud: 'Kimlik doğrulama veya deepfake kimliğe bürünme yok',
        noFinancialInstructions: 'Mali talimatlar veya hesap erişimi yok',
        noMedicalLegalAdvice: 'Kişinin adına tıbbi veya yasal tavsiye yok',
        noPoliticalPropaganda: 'Politik propaganda veya hedefli ikna yok',
        noHiddenUse: 'Gizli veya aldatıcı kullanım yok — simülasyon her zaman açıklanmalıdır',
        
        // Privacy & Security Section
        privacySecurityTitle: 'Gizlilik, Güvenlik ve Veri Kontrolü',
        encryption: 'Şifreleme',
        encryptionDesc: 'Saklanan anıları ve kayıtları korumak için iletim ve dinlenme sırasında şifreleme',
        accessControls: 'Erişim Kontrolleri',
        accessControlsDesc: 'Her etkileşimin izlenebilir olması için erişim kontrolleri ve denetim günlükleri',
        dataMinimization: 'Veri Minimizasyonu',
        dataMinimizationDesc: 'Yalnızca varlığı oluşturmak için gerekli olanı topluyoruz',
        rightToDelete: 'Silme Hakkı',
        rightToDeleteDesc: 'Varlıklar kullanıcı isteklerine göre duraklatılabilir, kaldırılabilir veya dışa aktarılabilir',
        
        // Evaluation & Feedback Section
        evaluationTitle: 'Değerlendirme, Geri Bildirim ve Düzeltme',
        evaluationDescription: 'Yakın arkadaşlar, aile ve güvenilir kişiler bir varlığı gözden geçirmede önemli bir rol oynar. Benzerliği değerlendirebilir, yanlışlıkları işaretleyebilir ve yanlış hatırlanan veya istenmeyen içeriğin düzeltilmesini talep edebilirler.',
        rateSimilarity: 'Benzerliği Değerlendir',
        rateSimilarityDesc: 'Güvenilir gözden geçirenler varlığın kişiyi ne kadar doğru yansıttığını değerlendirir',
        flagInaccuracies: 'Yanlışlıkları İşaretle',
        flagInaccuraciesDesc: 'Yanlış hatırlanan gerçekleri veya karaktere uymayan yanıtları bildirin',
        requestCorrections: 'Düzeltme Talep Et',
        requestCorrectionsDesc: 'İstenmeyen içeriği kaldırın veya davranış kalıplarını ayarlayın',
      },
      
      // Ethics Consent Page
      ethicsConsent: {
        title: 'Rıza ve Haklar',
        subtitle: 'Her dijital varlık açık, bilinçli rıza gerektirir. Saygınlık ve özerkliği nasıl sağladığımız aşağıda açıklanmıştır.',
        
        // Consent Flow
        consentFlowTitle: 'Rıza Akışı',
        whoCanCreate: 'Kim bir varlık oluşturabilir?',
        whoCanCreateDesc: 'Yalnızca kişinin kendisi veya yasal yetkiye sahip belirlenmiş bir temsilci (vasi, vekaletname).',
        whatMustBeDisclosed: 'Neler açıklanmalıdır?',
        whatMustBeDisclosedDesc: 'Amaç, kapsam, kimler etkileşimde bulunabilir, veriler nasıl kullanılacak ve saklama politikası.',
        canConsentBeWithdrawn: 'Rıza geri çekilebilir mi?',
        canConsentBeWithdrawnDesc: 'Evet. Her zaman, varlık duraklatılabilir veya silinebilir. Veriler 30 gün içinde temizlenir.',
        
        // Rights
        yourRightsTitle: 'Haklarınız',
        rightToAccess: 'Erişim Hakkı',
        rightToAccessDesc: 'Varlığınız hakkında saklanan tüm verileri görüntüleyin',
        rightToRectification: 'Düzeltme Hakkı',
        rightToRectificationDesc: 'Yanlış bilgileri düzeltin',
        rightToErasure: 'Silme Hakkı',
        rightToErasureDesc: 'Varlığınızı ve tüm ilgili verileri silin',
        rightToPortability: 'Taşınabilirlik Hakkı',
        rightToPortabilityDesc: 'Verilerinizi makine tarafından okunabilir bir formatta dışa aktarın',
        
        // Legal Framework
        legalFrameworkTitle: 'Yasal Çerçeve',
        legalFrameworkDesc: 'Rıza modelimiz şunlarla uyumludur:',
        gdpr: 'GDPR (Genel Veri Koruma Yönetmeliği)',
        ccpa: 'CCPA (Kaliforniya Tüketici Gizlilik Yasası)',
        ieee: 'IEEE P7000 serisi etik yapay zeka tasarımı',
      },
      
      // Presence Pages
      presence: {
        // Layout
        presencePrefix: 'RepresenX Varlık',
        presenceId: 'Varlık #',
        chat: 'Sohbet',
        activity: 'Aktivite',
        consent: 'Rıza',
        memory: 'Hafıza',
        settings: 'Ayarlar',
        training: 'Eğitim',
        
        // ChatPage
        conversation: 'Konuşma',
        liveWith: 'Canlı -',
        session: 'Oturum',
        sessionInfo: 'Oturum Bilgisi',
        messages: 'Mesajlar',
        emptyChat: 'Bir konuşma başlatın. Varlık anılar, kişilik ve güvenlik filtreleri kullanarak yanıt verecektir.',
        askSomething: 'Bu varlığın önemseyeceği bir şey sorun…',
        presenceThinking: 'Varlık düşünüyor…',
        safeModeResponse: 'Güvenli mod yanıtı',
        traceability: 'İzlenebilirlik',
        systemMessage: 'Sistem mesajı',
        somethingWentWrong: 'Varlıkla iletişim kurarken bir sorun oluştu.',
        clickTraceability: 'Bir yanıttaki',
        clickTraceabilityLink: 'İzlenebilirlik ↗',
        clickTraceabilityDesc: 'bağlantısına tıklayarak anıları, kişiliği ve yönetişim kararlarını inceleyin.',
        
        // TraceabilityModal
        traceabilityTitle: 'İzlenebilirlik',
        responseDiagnostics: 'Yanıt tanılamaları',
        loading: 'Yükleniyor…',
        noTraceabilityRecord: 'İzlenebilirlik kaydı bulunamadı.',
        inputOutput: 'Girdi / Çıktı',
        userMessage: 'Kullanıcı mesajı',
        response: 'Yanıt',
        memoriesUsed: 'Kullanılan Anılar',
        noMemoriesInjected: 'Anı eklenmedi.',
        governance: 'Yönetişim',
        categoriesTriggered: 'Tetiklenen kategoriler',
        none: 'Yok',
        personaSnapshot: 'Kişilik anlık görüntüsü',
        
        // ConsentPage
        consentLegalBasis: 'Rıza ve Yasal Dayanak',
        consentDescription: 'Dijital varlığınızın çalışabilmesi için açık rızanız gereklidir. Rıza vererek kişisel verilerinizin işlenmesine, yapay zeka modellerinin eğitilmesine ve varlığınızın sizin adınıza konuşma yapmasına izin vermiş olursunuz. Bu rıza istediğiniz zaman geri çekilebilir.',
        loadingConsent: 'Rıza verileri yükleniyor…',
        currentStatus: 'Mevcut durum',
        activeConsent: 'Aktif rıza',
        withdrawn: 'Geri çekildi',
        noConsent: 'Yok',
        acceptedAt: 'Kabul edilme zamanı',
        withdrawnAt: 'Geri çekilme zamanı',
        acceptConsent: 'Rızayı Kabul Et',
        accepting: 'Kabul ediliyor…',
        consentAccepted: 'Rıza kabul edildi!',
        consentAcceptedDesc: 'Artık varlığınızla sohbet edebilirsiniz',
        consentAcceptError: 'Rıza kabul edilemedi',
        tryAgain: 'Lütfen tekrar deneyin',
        withdrawConsent: 'Rızayı Geri Çek',
        withdrawing: 'Geri çekiliyor…',
        latestForm: 'En Son Form',
        effectiveFrom: 'Yürürlük tarihi',
        
        // ActivityPage
        activitySafety: 'Aktivite ve Güvenlik',
        activityOverview: 'Bu varlık için sohbet kullanımı ve güvenlik olaylarına genel bakış.',
        loadingActivity: 'Aktivite yükleniyor…',
        totalActivities: 'Toplam Aktiviteler (30g)',
        llmInteractions: 'LLM Etkileşimleri',
        auditEvents: 'Denetim Olayları',
        recentEvents: 'Son olaylar',
        noEventsYet: 'Henüz olay yok.',
        event: 'Olay',
      },
      
      // Presence List Page
      presenceList: {
        title: 'Dijital Varlıklar',
        totalCount: 'toplam',
        filterAll: 'Tümü',
        filterActive: 'Aktif',
        filterPaused: 'Duraklatılmış',
        loading: 'Yükleniyor...',
        
        // Card
        unnamed: 'İsimsiz varlık',
        created: 'Oluşturulma',
        noDescription: 'Bu varlık için henüz açıklama eklenmedi.',
        
        // Status
        statusActive: 'Aktif',
        statusPaused: 'Duraklatılmış',
        statusDeleted: 'Silindi',
        
        // Stats
        chats30d: 'Sohbetler (30g)',
        blocked: 'Engellenen',
        withMemory: 'Hafızalı',
        chatsCount: 'sohbet',
        blockedCount: 'engellenen',
        
        // Actions
        clickToOpen: 'Çalışma alanını açmak için tıklayın',
        open: 'Aç',
        openWorkspace: 'Çalışma alanını aç',
        
        // Quick Actions Menu
        resumePresence: 'Varlığı devam ettir',
        pausePresence: 'Varlığı duraklat',
        shareAccess: 'Erişimi paylaş',
        settings: 'Ayarlar',
        
        // Role & Online Status
        owner: 'Sahip',
        shared: 'Paylaşılan',
        online: 'Varlık çevrimiçi',
        idle: 'Varlık boşta',
        lastChat: 'Son sohbet',
        
        // Empty State
        emptyTitle: 'Henüz varlık yok.',
        emptyDesc: 'Bir varlık oluşturduğunuzda, burada canlı kullanım ve güvenlik istatistikleriyle birlikte görünecektir.',
        
        // Status Messages
        consentRequired: 'Bu varlığın çalışması için rıza gereklidir.',
        presencePausedMessage: 'Bu varlık duraklatıldı. Yeni konuşmalara izin vermek için devam ettirin.',
        noPermission: 'Bu varlık için sohbet iznine sahip değilsiniz.'
      },
      
      // Pricing Page
      pricing: {
        title: 'Yolculuğunuza Uygun Varlığı Seçin',
        
        // Plans
        basicPresence: 'Temel Varlık',
        enhancedPersona: 'Gelişmiş Kişilik',
        legacyContinuum: 'Miras Sürekliliği',
        enterpriseIdentity: 'Kurumsal Kimlik',
        
        perMonth: '/ay',
        custom: 'Özel',
        
        // Basic Presence Features
        voiceSimulation: 'Ses simülasyonu',
        basicStyleMapping: 'Temel stil haritalama',
        limitedMemoryAnchoring: 'Sınırlı hafıza sabitleme',
        standardPrivacyTools: 'Standart gizlilik araçları',
        
        // Enhanced Persona Features
        fullStyleToolkit: 'Tam stil araç seti',
        extendedMemoryGraph: 'Genişletilmiş hafıza grafiği',
        behavioralTuning: 'Davranışsal ayarlama',
        ethicalCoreCustomization: 'Etik çekirdek özelleştirme',
        
        // Legacy Continuum Features
        lifeStoryStructuring: 'Yaşam hikayesi yapılandırma',
        legacyModeDataHandling: 'Miras modu veri işleme',
        multiGenerationMemory: 'Çok nesil hafıza',
        premiumPrivacyControls: 'Premium gizlilik kontrolleri',
        
        // Enterprise Identity Features
        apiAccess: 'API erişimi',
        multiProfileSystems: 'Çoklu profil sistemleri',
        secureDeployment: 'Güvenli dağıtım',
        dedicatedSupport: 'Özel destek ve SLA\'lar',
        
        // CTAs
        startBasic: 'Temele Başla',
        upgradeToEnhanced: 'Gelişmiş\'e Yükselt',
        buildYourLegacy: 'Mirasınızı Oluşturun',
        contactSales: 'Satış Ekibiyle İletişime Geçin'
      },
      
      // Features Page
      features: {
        title: 'Varlığınızı Hayata Geçiren Özellikler',
        subtitle: 'Sizi benzersiz kılan şeyleri yakalayan ve ifade eden gelişmiş araçlar.',
        
        voiceSimulation: 'Ses Simülasyonu',
        voiceSimulationDesc: 'Gelişmiş ses modelleme teknolojisiyle tonunuzu ve konuşma tarzınızı yeniden oluşturun.',
        
        toneStyle: 'Ton ve Stil Haritalama',
        toneStyleDesc: 'Varlığınızın farklı bağlamlarda ne kadar etkileyici, resmi veya doğrudan olması gerektiğini tanımlayın.',
        
        memoryAnchoring: 'Hafıza Sabitleme',
        memoryAnchoringDesc: 'Bağlamsal yanıtlara rehberlik eden ve anlamlı bağlantılar oluşturan hayat anlarını ekleyin.',
        
        valueBasedResponses: 'Değer Tabanlı Yanıtlar',
        valueBasedResponsesDesc: 'İlkeleriniz varlığınızın mantığını oluşturur ve etik uyumu sağlar.',
        
        lifeStory: 'Yaşam Hikayesi Yapılandırma',
        lifeStoryDesc: 'Anıları dijital kimliğinizi şekillendiren tutarlı bir anlatı haritasına bağlayın.',
        
        identityContinuity: 'Kimlik Sürekliliği',
        identityContinuityDesc: 'Deneyimleriniz büyüdükçe varlığınızı güncelleyin, otantik evrimi sürdürün.',
        
        socialMediaImport: 'Sosyal Medya Verilerinden Öğrenme',
        socialMediaImportDesc: 'Instagram, Twitter veya Facebook arşivinizi yükleyin. GPT-4 gönderilerinizi analiz ederek otomatik olarak hafızalar, ilgi alanları ve Q&A örnekleri oluşturur. Dijital varlığınızı hızlıca zenginleştirin.',
        
        trainingModule: 'Eğitim Merkezi',
        trainingModuleDesc: 'Q&A örnekleri ekleyin, konuşmaları gözden geçirin, toplu veri yükleyin ve eğitim metriklerini takip edin. Varlığınızı sürekli iyileştirmek için kapsamlı araçlar.',
        
        autoLearning: 'Otomatik Öğrenme',
        autoLearningDesc: 'GPT-4 konuşmalarınızı analiz eder ve yüksek kaliteli Q&A önerileri oluşturur. Onaylayın veya reddedin — varlığınız zamanla daha akıllı hale gelir.'
      },
      
      // Technology Page
      technology: {
        title: 'RepresenX Nasıl Çalışır',
        subtitle: 'Kimlik, hafıza ve yönetişimi birleştiren katmanlı bir sistem.',
        description: 'RepresenX, stil, değerler, anılar ve güvenlik kurallarını ayrı katmanlara ayırır. Tek bir kara kutu yerine, her varlığı açıklanabilir, kontrol edilebilir ve rızaya saygılı kılan bir mimari kullanırız.',
        viewArchitecture: 'Varlık Mimarisini Görüntüle',
        learnGovernance: 'Yönetişim Katmanı Hakkında Bilgi Edinin',
        
        // Architecture sections
        architectureTitle: 'Dijital Varlığınızın Arkasındaki Mimari',
        architectureSubtitle: 'RepresenX, ses modellemesi, değer haritalama, hafıza bağlama ve davranışsal süreklilik birleştirerek birleşik bir dijital varlık oluşturur.',
        
        inputLayer: 'Giriş Katmanı',
        inputLayerDesc: 'Ses, Değerler, Anılar, Tercihler',
        processingLayers: 'İşleme Katmanları',
        processingLayersDesc: 'Stil, İfade, Etik Çekirdek',
        outputLayer: 'Çıkış Katmanı',
        outputLayerDesc: 'Varlık Yanıtı',
        
        // Multi-layer simulation
        simulationTitle: 'Otantik Etkileşim için Çok Katmanlı Simülasyon',
        styleLayer: 'Stil Katmanı',
        styleLayerDesc: 'Cümle yapısı, ritim ve dilsel nüansları yakalar.',
        expressionLayer: 'İfade Katmanı',
        expressionLayerDesc: 'Duygusal tonu ve konuşma enerjisini yeniden üretir.',
        memoryNodes: 'Hafıza Düğümleri',
        memoryNodesDesc: 'Önemli anıları bağlamsal yanıtlara bağlar.',
        ethicalGuardrails: 'Etik Korkuluklar',
        ethicalGuardrailsDesc: 'Varlığınızın kişisel ilkelerinizle uyumlu kalmasını sağlar.',
        
        // Identity & Memory Architecture
        identityMemoryTitle: 'Kimlik, Hafıza ve Varlık Mimarisi',
        identityMemoryDesc: 'RepresenX kimliği katmanlı bir sistem olarak modellemektedir: stil, değerler, anılar ve davranış. Tek bir monolitik model yerine, epizodik anıları, semantik bilgiyi ve iletişim stilini birlikte çalışan ayrı katmanlara ayırıyoruz.',
        episodicMemory: 'Epizodik Hafıza',
        episodicMemoryDesc: 'Önemli anlar, hikayeler, yerler ve ilişkiler yapılandırılmış anılar olarak saklanır ve yalnızca konuşmayla alakalı olduklarında geri alınır.',
        semanticKnowledge: 'Semantik Bilgi',
        semanticKnowledgeDesc: 'Profesyonel konular, ilgi alanları ve tekrar eden temalar kişinin perspektifiyle bağlantılı bilgi kümeleri olarak temsil edilir.',
        styleValuesLayer: 'Stil ve Değerler Katmanı',
        styleValuesLayerDesc: 'Ton, ritim, kelime seçimi ve kişisel ilkeler varlığın nasıl yanıt verdiğini şekillendirir — sadece ne söylediğini değil.',
        
        // Persona Cards
        personaCardsTitle: 'Kişilik Kartları: Yapılandırılmış Stil, Değerler ve Sınırlar',
        personaCardsDesc: 'RepresenX\'teki her varlık bir "Kişilik Kartı" ile yönlendirilir — ton, tercihler, değerler ve kesin sınırları tanımlayan yapılandırılmış bir profil. Sisteme sadece nasıl konuşacağını değil, aynı zamanda asla ne yapmaması gerektiğini de söyler.',
        toneStyle: 'Ton ve Stil',
        toneStyleDetail: 'Sıcaklık, mizah, formalite, tipik cümle uzunluğu',
        linguisticPatterns: 'Dilsel Kalıplar',
        linguisticPatternsDetail: 'Dolgu sözcükleri, geçişler, yaygın ifadeler',
        valuesPrinciples: 'Değerler ve İlkeler',
        valuesPrinciplesDetail: 'Her zaman öncelik verilmesi gerekenler ve kaçınılması gereken konular',
        safetyRules: 'Güvenlik Kuralları',
        safetyRulesDetail: 'Yüksek riskli istekleri varsayılan olarak reddetme talimatları',
        personaCardsFooter: 'Kişilik Kartları her varlığı tutarlı, saygılı ve kişinin bilinen değerleriyle uyumlu tutar.',
        
        // Governance Layer
        governanceTitle: 'Yönetişim Katmanı: Varlığın Asla Yapmayacağı Şeyler',
        governanceDesc: 'Stil ve hafızanın ötesinde, RepresenX pazarlık edilemez güvenlik kurallarını uygulayan bir yönetişim katmanı içerir. Belirli davranış kategorileri politika ve teknik düzeyde engellenir.',
        blockedByDesign: 'Tasarımla Engellenen',
        identityVerification: 'Kimlik doğrulama ve şifre kurtarma',
        financialTransfers: 'Mali transferler veya ödeme talimatları',
        medicalLegalAdvice: 'Tıbbi veya yasal tavsiye',
        politicalPersuasion: 'Politik ikna veya kampanya',
        safetyControls: 'Güvenlik Kontrolleri',
        policyAwareFilters: 'Politika farkındalığına sahip yanıt filtreleri',
        refusalTemplates: 'Riskli istekler için ret şablonları',
        continuousLogging: 'Sürekli günlük kaydı ve denetlenebilirlik',
        watermarkedAudio: 'İzlenebilirlik için filigranlanmış sentetik ses',
        
        // Security
        securityTitle: 'Güven İçin Tasarlandı',
        industryEncryption: 'Endüstri standardı şifreleme',
        transparentControls: 'Şeffaf veri kontrolleri',
        localStorage: 'İsteğe bağlı yerel öncelikli depolama',
        valueBehavior: 'Davranış değerlerinizle sınırlandırılmış',
        
        // Demo
        demoTitle: 'Varlık Motorunu Hareket Halinde Görün',
        demoDesc: 'Varlığınızın girişleri nasıl yorumladığını ve etik, insana benzer yanıtları nasıl oluşturduğunu gösteren rehberli bir önizleme.',
        watchDemo: 'Demo İzle',
        
        personaLayer: 'Kişilik Katmanı',
        personaDesc: 'Tonunuzu, tarzınızı ve ifade kalıplarınızı tanımlar.',
        
        memoryLayer: 'Hafıza Katmanı',
        memoryDesc: 'Bağlamı ve geçmiş etkileşimleri depolamak için RAG sistemi.',
        
        chatLayer: 'Sohbet Katmanı',
        chatDesc: 'Doğal yanıtlar üretmek için LLM entegrasyonu.',
        
        governanceLayer: 'Yönetişim Katmanı',
        governanceDesc: 'Rıza sınırlarını ve kullanım kısıtlamalarını uygular.',
        
        consentLayer: 'Rıza Katmanı',
        consentDesc: 'İzin verilen eylemleri ve sınırları yönetir.',
        
        accessControlLayer: 'Erişim Kontrolü Katmanı',
        accessControlDesc: 'Varlığınızla kimlerin etkileşime girebileceğini belirler.',
        
        logsLayer: 'Günlükler Katmanı',
        logsDesc: 'Şeffaflık ve hesap verebilirlik için izlenebilir davranış.'
      },
      
      // Presences List
      presences: {
        title: 'Varlıklarım',
        subtitle: 'Tüm dijital varlıklarınızı tek yerden yönetin',
        createNew: 'Yeni Varlık Oluştur',
        searchPlaceholder: 'Varlıkları ada göre ara...',
        filterAll: 'Tümü',
        filterActive: 'Aktif',
        filterPaused: 'Duraklatılmış',
        loading: 'Varlıklarınız yükleniyor...',
        noPresences: 'Henüz varlık yok',
        noPresencesDesc: 'İlk dijital varlığınızı oluşturarak başlayın',
        viewDetails: 'Detayları Görüntüle',
        manage: 'Yönet',
        delete: 'Sil',
        deleteConfirm: 'Varlığı Sil?',
        deleteConfirmMessage: 'Bu varlık ve tüm ilişkili verileri (anılar, konuşmalar) kalıcı olarak silinecek. Bu işlem geri alınamaz.',
        cancel: 'İptal',
        confirmDelete: 'Evet, Sil',
        deleteSuccess: 'Varlık başarıyla silindi',
        deleteError: 'Varlık silinirken bir hata oluştu'
      },
      
      training: {
        title: 'Varlık Eğitim Merkezi',
        description: 'Varlığınızı soru-cevap örnekleri, konuşma incelemeleri ve toplu veri yüklemeleriyle eğitin.',
        qaExamples: 'Soru-Cevap Örnekleri',
        conversationReview: 'Konuşma İncelemesi',
        bulkUpload: 'Toplu Yükleme',
        metrics: 'Eğitim Metrikleri',
        
        addNewQA: 'Yeni Soru-Cevap Ekle',
        question: 'Soru',
        answer: 'Cevap',
        category: 'Kategori',
        questionPlaceholder: 'Örnek: En sevdiğin renk nedir?',
        answerPlaceholder: 'Örnek: Mavi, özellikle lacivert tonları.',
        
        categoryGeneral: 'Genel',
        categoryPersonal: 'Kişisel',
        categoryProfessional: 'Profesyonel',
        categoryFamily: 'Aile',
        categoryHobbies: 'Hobiler',
        
        addExample: 'Örnek Ekle',
        existingExamples: 'Mevcut Örnekler',
        loading: 'Yükleniyor...',
        noExamples: 'Henüz örnek eklenmemiş. Yukarıdaki formu kullanarak ilk örneğinizi ekleyin.',
        
        delete: 'Sil',
        confirmDelete: 'Bu örneği silmek istediğinizden emin misiniz?',
        
        qaAdded: 'Soru-cevap örneği eklendi!',
        qaDeleted: 'Örnek silindi.',
        fillAllFields: 'Lütfen tüm alanları doldurun.',
        loadError: 'Eğitim verileri yüklenemedi.',
        addError: 'Örnek eklenemedi.',
        deleteError: 'Örnek silinemedi.',
        
        reviewDescription: 'Geçmiş konuşmaları inceleyin ve yanıtları değerlendirin.',
        bulkDescription: 'CSV veya JSON formatında toplu soru-cevap örnekleri yükleyin.',
        metricsDescription: 'Eğitim ilerlemesini ve varlık performansını görüntüleyin.',
        comingSoon: 'Yakında gelecek...',
        
        // Review
        pendingReviews: 'İnceleme Bekleyen Konuşmalar',
        noReviews: 'İnceleme bekleyen konuşma yok.',
        userQuestion: 'Kullanıcı Sorusu',
        botAnswer: 'Varlık Yanıtı',
        goodAnswer: 'İyi Yanıt',
        correctAnswer: 'Düzelt',
        correctedAnswer: 'Düzeltilmiş Yanıt',
        enterCorrectedAnswer: 'Doğru yanıtı girin...',
        saveCorrection: 'Düzeltmeyi Kaydet',
        cancel: 'İptal',
        feedbackSaved: 'Değerlendirme kaydedildi!',
        answerCorrected: 'Yanıt düzeltildi ve Q&A\'ya eklendi!',
        fillCorrectedAnswer: 'Lütfen düzeltilmiş yanıtı girin.',
        reviewsLoadError: 'Konuşmalar yüklenemedi.',
        feedbackError: 'Değerlendirme kaydedilemedi.',
        correctionError: 'Düzeltme kaydedilemedi.',
        
        // Bulk Upload
        selectFile: 'Dosya Seç',
        fileFormats: 'CSV veya JSON formatında (max 10MB)',
        expectedFormat: 'Beklenen Format',
        uploadFile: 'Dosyayı Yükle',
        uploading: 'Yükleniyor...',
        preview: 'Önizleme',
        ofTotal: 'toplam',
        examplesUploaded: 'örnek yüklendi!',
        noFileSelected: 'Lütfen bir dosya seçin.',
        fileParseError: 'Dosya okunamadı. Format kontrol edin.',
        uploadError: 'Yükleme başarısız.',
        
        // Metrics
        totalQA: 'Toplam Q&A',
        feedbackCount: 'Toplam Değerlendirme',
        averageRating: 'Ortalama Puan',
        convertedQA: 'Q&A\'ya Çevrilen',
        categoryBreakdown: 'Kategori Dağılımı',
        feedbackStats: 'Değerlendirme İstatistikleri',
        thumbsUp: 'Olumlu',
        thumbsDown: 'Olumsuz',
        noMetrics: 'Henüz metrik yok.',
        metricsLoadError: 'Metrikler yüklenemedi.',
        
        // Additional help text
        reviewHelp: 'Presence\'ın verdiği yanıtları değerlendirin veya düzeltin',
        noReviewsDesc: 'Tüm konuşmalar değerlendirilmiş. Yeni sohbetler bekleyin.',
        
        // Auto-Learning Tab
        autoLearning: 'Otomatik Öğrenme',
        suggestions: 'Öneriler',
        learningSuggestions: 'Öğrenme Önerileri',
        suggestionsDesc: 'Konuşmalardan otomatik oluşturulan Q&A önerileri',
        pendingSuggestions: 'Bekleyen Öneriler',
        noSuggestions: 'Henüz öneri yok',
        noSuggestionsDesc: 'Konuşmalar analiz edildiğinde öneriler burada görünecek',
        confidence: 'Güvenilirlik',
        reason: 'Sebep',
        approveSuggestion: 'Onayla',
        rejectSuggestion: 'Reddet',
        suggestionApproved: 'Öneri onaylandı ve eğitim datasına eklendi',
        suggestionRejected: 'Öneri reddedildi',
        approveError: 'Onaylama hatası',
        rejectError: 'Reddetme hatası',
        autoLearningSettings: 'Otomatik Öğrenme Ayarları',
        enableAutoLearning: 'Otomatik Öğrenmeyi Etkinleştir',
        learningMode: 'Öğrenme Modu',
        manualMode: 'Manuel İnceleme',
        autoMode: 'Otomatik Onay',
        minConfidenceLevel: 'Minimum Güvenilirlik',
        autoLearningStats: 'İstatistikler',
        totalGenerated: 'Toplam Üretilen',
        waitingReview: 'İnceleme Bekliyor',
        autoApproved: 'Otomatik Onaylandı',
        manuallyRejected: 'Manuel Reddedildi'
      },
      
      // Memory Module
      memory: {
        knowledgeBase: 'Bilgi Tabanı',
        addMemory: 'Hafıza Ekle',
        whatIsThis: 'Bu ne işe yarar?',
        explanation: 'Hafıza sistemi, dijital varlığınızın sizinle ilgili ne bildiğini yönetir. Anılar ve bilgiler ekleyerek varlığınızı daha kişisel ve gerçekçi hale getirirsiniz.',
        
        // Memory Types
        episodic: 'Episodik',
        episodicDesc: 'Yaşanan olaylar, anılar (örn: "2023\'te İstanbul\'u ziyaret ettim")',
        semantic: 'Semantik',
        semanticDesc: 'Bilgiler, tercihler (örn: "En sevdiğim renk mavi")',
        
        // Form Fields
        title: 'Başlık',
        description: 'Açıklama',
        date: 'Tarih',
        emotion: 'Duygu',
        positive: 'Olumlu',
        neutral: 'Nötr',
        negative: 'Olumsuz',
        relatedPeople: 'İlgili Kişiler',
        relatedPeoplePlaceholder: 'virgülle ayırın (örn: Ahmet, Ayşe)',
        topic: 'Konu',
        topicPlaceholder: 'örn: müzik, spor, teknoloji',
        tags: 'Etiketler',
        tagsPlaceholder: 'virgülle ayırın',
        
        // Placeholders
        episodicTitlePlaceholder: 'örn: Paris gezisi',
        semanticTitlePlaceholder: 'örn: En sevdiğim yemek',
        descriptionPlaceholder: 'Detaylı açıklama yazın...',
        
        // Help Text
        episodicHelp: 'Yaşadığınız özel bir anı veya olayı kaydedin',
        semanticHelp: 'Bir bilgi, tercih veya gerçeği kaydedin',
        
        // Messages
        fillRequired: 'Başlık ve açıklama zorunludur',
        memoryAdded: 'Hafıza başarıyla eklendi',
        addError: 'Hafıza eklenirken hata oluştu',
        saving: 'Kaydediliyor...',
        save: 'Kaydet'
      },
      
      // Audio Module
      audio: {
        recording: 'Kaydediliyor',
        stopRecording: 'Durdur',
        startRecording: 'Kayıt Başlat',
        listening: 'Dinleniyor...',
        microphoneError: 'Mikrofon erişimi reddedildi. Lütfen tarayıcı ayarlarınızı kontrol edin.',
        transcriptionError: 'Ses metne çevrilemedi. Lütfen tekrar deneyin.',
        playAudio: 'Sesi Çal',
        ttsError: 'Ses oluşturulamadı'
      },
      
      // Footer
      footer: {
        copyright: '© Temsilin Geleceği',
        ethicsGovernance: 'Etik ve Yönetişim',
        privacy: 'Gizlilik',
        terms: 'Şartlar',
        contact: 'İletişim'
      },
      
      // Common
      common: {
        save: 'Kaydet',
        cancel: 'İptal',
        delete: 'Sil',
        edit: 'Düzenle',
        search: 'Ara',
        filter: 'Filtrele',
        loading: 'Yükleniyor...',
        error: 'Bir hata oluştu',
        success: 'İşlem başarılı',
        back: 'Geri',
        next: 'İleri',
        finish: 'Bitir',
        close: 'Kapat'
      }
    }
  },
  en: {
    translation: {
      lang: 'en',
      // Navigation
      nav: {
        // Authenticated navigation
        dashboard: 'Dashboard',
        myPresences: 'My Presences',
        create: 'Create',
        settings: 'Settings',
        help: 'Help',
        logout: 'Logout',
        
        // Public navigation
        home: 'Home',
        technology: 'Technology',
        features: 'Features',
        pricing: 'Pricing',
        ethics: 'Ethics & Governance'
      },
      
      // Landing/Welcome Page
      landing: {
        welcome: 'Welcome to RepresenX',
        subtitle: 'Create your AI-powered digital identity',
        getStarted: 'Get Started',
        learnMore: 'Learn More',
        login: 'Login',
        register: 'Register'
      },
      
      // Home Page
      home: {
        ethicsBadge: 'Simulation · Ethically Governed',
        tagline: 'More Than Memory — A Presence.',
        description: 'A digital presence that captures your values, your voice, and the essence of who you are. Not a copy — a reflection shaped by what truly defines you.',
        disclaimer: 'RepresenX is a values-aligned simulation. It is not the real person.',
        createYourPresence: 'Create Your Presence',
        learnTechnology: 'Learn the Technology',
        
        // Block 2 - Presence Engine
        presenceEngineTitle: 'The Presence Engine',
        presenceEngineSubtitle: 'RepresenX is powered by an intelligent engine designed to understand how you speak, what you value, and how you express yourself — creating a presence that feels authentically yours.',
        voiceStyleTitle: 'Voice & Style Simulation',
        voiceStyleDesc: 'Recreates your tone, rhythm, and expression patterns with precision.',
        valueMappingTitle: 'Value Mapping',
        valueMappingDesc: 'Your personal principles guide the behavior of your presence.',
        behaviorTitle: 'Behavior Learning',
        behaviorDesc: 'Consistent interaction patterns that evolve as you evolve.',
        socialMediaImportTitle: 'Social Media Import',
        socialMediaImportDesc: 'Upload your Instagram, Twitter, or Facebook data and let GPT-4 automatically create memories and Q&A examples.',
        
        // Block 3 - Demo Preview
        presenceInActionTitle: 'Your Presence in Action',
        presenceInActionDesc: 'Experience how RepresenX interacts, responds, and reflects your tone and values.',
        
        // Block 3.5 - Training & Learning
        trainingTitle: 'Continuously Improve Your Presence',
        trainingSubtitle: 'Train and enrich your digital presence with Q&A examples, conversation reviews, and automatic learning.',
        trainingModuleTitle: 'Training Center',
        trainingModuleDesc: 'Comprehensive tools and control to train your presence.',
        trainingFeature1: 'Add and manage Q&A examples',
        trainingFeature2: 'Rapid training with bulk data upload',
        trainingFeature3: 'Training metrics and progress tracking',
        autoLearningTitle: 'Auto-Learning',
        autoLearningDesc: 'GPT-4 analyzes your conversations and generates new Q&A suggestions.',
        autoLearningFeature1: 'Automatic Q&A extraction from conversations',
        autoLearningFeature2: 'Smart suggestions with confidence scores',
        autoLearningFeature3: 'Controlled learning with approve/reject',
        
        // Block 4 - Use Cases
        useCasesTitle: 'Where RepresenX Makes a Difference',
        legacyTitle: 'Legacy Presence',
        legacyDesc: 'Preserve your essence for loved ones — beyond time and distance.',
        companionTitle: 'Personal AI Companion',
        companionDesc: 'An AI that understands you deeply and grows with you.',
        professionalTitle: 'Professional Persona',
        professionalDesc: 'Extend your expertise with a scalable, consistent digital identity.',
        memoryTitle: 'Memory Preservation',
        memoryDesc: 'Transform memories into a connected narrative.',
        
        // Block 5 - Ethics
        ethicsTitle: 'Built on Ethics. Powered by Consent.',
        ethicsSubtitle: 'RepresenX is designed as a respectful simulation — not a replacement for any person. Every presence is created with explicit consent, limited by clear boundaries, and operated under strict privacy, safety, and transparency standards.',
        consentTitle: 'Explicit Consent',
        consentDesc: 'Presences are only created and used with clear, documented consent and the approval of appropriate stewards when needed.',
        boundariesTitle: 'Clear Boundaries',
        boundariesDesc: 'High-risk use cases such as financial instructions, identity verification, medical or legal advice, and political persuasion are blocked by design.',
        transparencyTitle: 'Transparent Simulation',
        transparencyDesc: 'Every interaction clearly indicates that you are speaking to a simulation, with visible disclaimers and traceable behavior.',
        readEthicsPolicy: 'Read Full Ethics & Governance Policy'
      },
      
      // Auth Pages
      auth: {
        login: 'Login',
        register: 'Register',
        createAccount: 'Create an account',
        name: 'Name',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        loginButton: 'Login',
        registerButton: 'Register',
        alreadyHaveAccount: 'Already have an account?',
        dontHaveAccount: "Don't have an account?",
        forgotPassword: 'Forgot your password?',
        namePlaceholder: 'Enter your name',
        emailPlaceholder: 'Enter your email',
        passwordPlaceholder: 'Enter your password',
        confirmPasswordPlaceholder: 'Re-enter your password',
        // Toast messages
        loginSuccess: 'Welcome back!',
        loginSuccessDesc: 'Successfully logged in.',
        loginFailed: 'Login Failed',
        invalidCredentials: 'Invalid email or password. Please try again.',
        registerSuccess: 'Account Created!',
        registerSuccessDesc: 'Welcome to RepresenX.',
        registerFailed: 'Registration Failed',
        emailExists: 'This email address is already in use.'
      },
      
      // Dashboard
      dashboard: {
        title: 'Dashboard',
        welcomeBack: 'Welcome back. Your presences, activities, and controls in one place.',
        noPresences: 'No Presences Yet',
        noPresencesDesc: 'Create your first digital presence to get started.',
        selectPresence: 'Select a presence',
        
        // Metrics
        totalInteractions: 'Total Interactions',
        memoryNodes: 'Memory Nodes',
        activeConnections: 'Active Connections',
        accuracyScore: 'Accuracy Score',
        
        // Tabs
        overview: 'Overview',
        memory: 'Memory',
        activity: 'Activity',
        chat: 'Chat',
        
        // Activity Feed
        recentActivity: 'Recent Activity',
        noActivity: 'No activity yet',
        
        // Memory
        memoryGraph: 'Memory Graph',
        noMemories: 'No memories added yet',
        
        // Chat
        recentConversations: 'Recent Conversations',
        noConversations: 'No conversations yet',
        startChat: 'Start Chat',
        viewAll: 'View All',
        
        // Actions
        managePresence: 'Manage Presence',
        viewDetails: 'View Details',
        exportData: 'Export Data'
      },
      
      // Presence Creation
      presenceCreation: {
        title: 'Create a Presence',
        subtitle: 'A guided journey to build a simulation that reflects how you think, speak and care.',
        pageTitle: 'Create Your Presence - Step by Step',
        
        // Hero Bullets
        bullet1: 'Define consent, scope and access.',
        bullet2: 'Capture style, values and key memories.',
        bullet3: 'Preview and fine-tune before activating.',
        disclaimer: 'This is an AI-driven simulation, not the real person. You can pause or delete it at any time.',
        
        // Progress
        stepOf: 'Step',
        of: 'of',
        complete: 'Complete',
        
        // Steps
        consentTitle: 'Consent & Scope',
        consentIcon: 'shield',
        consentDescription: 'Define permissions, use cases, and boundaries before creating your presence.',
        consentHelper: 'Before creating a presence, we need to clearly define permissions and boundaries.',
        
        voiceSamplesTitle: 'Voice Samples',
        voiceSamplesDescription: 'Upload or record voice clips for tone analysis.',
        voiceSamplesPlaceholder: 'Describe your voice characteristics or upload audio samples...',
        voiceSamplesHelper: '30–120 seconds of varied speech helps the system understand tone and pacing.',
        
        styleTitle: 'Communication Style',
        styleDescription: 'Describe how you communicate — calm, humorous, direct, or expressive.',
        stylePlaceholder: 'e.g., warm, direct, humorous, reflective',
        styleHelper: 'Keywords help shape tone, pacing, and emotional energy.',
        
        valuesTitle: 'Core Values',
        valuesDescription: 'Define the beliefs that guide your presence.',
        valuesPlaceholder: 'e.g., empathy, fairness, honesty',
        valuesHelper: 'These guide how the presence makes decisions.',
        
        memoriesTitle: 'Memory Points',
        memoriesDescription: 'Add key moments that define your identity.',
        memoriesPlaceholder: 'e.g., "High school graduation", "Our first home"',
        memoriesHelper: 'Describe the event in 1–3 sentences.',
        
        previewTitle: 'Preview Presence',
        previewDescription: 'See how your presence behaves in sample conversations.',
        previewHelper: 'Review how the presence responds using your data and style settings.',
        
        saveTitle: 'Save & Activate',
        saveDescription: 'Finalize settings and activate your presence.',
        saveHelper: 'You can pause or delete the presence anytime from the Dashboard.',
        
        // Step 0 - Consent
        consentNotice: 'Before creating a presence, we need to clearly define what data can be used, who may access the presence, and for what purposes it can be activated.',
        whoIsThisFor: 'Who is this presence for?',
        whoIsThisForDesc: 'Choose whether you\'re creating a presence for yourself or someone you have legal authority to represent.',
        myself: 'Myself',
        familyMember: 'A family member (with legal authority)',
        
        // Buttons
        next: 'Next',
        back: 'Back',
        skipStep: 'Skip This Step',
        saveDraft: 'Save Draft',
        finish: 'Finish & Activate',
        creating: 'Creating...',
        
        // Success Screen
        successTitle: 'Your presence is ready.',
        successMessage: 'You can adjust style, memories, and safety settings at any time.',
        goToDashboard: 'Go to Dashboard',
        startUsing: 'Start Using Presence',
        autoRedirect: 'Auto-redirecting to dashboard...',
        autoRedirectTime: 'Auto-redirecting to dashboard in 4 seconds...',
        
        // Validation Messages
        fixErrors: 'Please fix the errors before continuing',
        specifyUseCase: 'Please specify at least one permitted use case.',
        approveDataType: 'You must approve at least one data type.',
        invalidEmails: 'One or more email addresses are invalid.',
        confirmNotice: 'You must confirm the simulation notice.',
        describeStyle: 'Please describe at least one style characteristic.',
        includeValue: 'Please include at least one core value.',
        providePresenceName: 'Please provide a name for your presence.',
        
        // Draft Save
        draftSaved: 'Draft saved successfully',
        draftSavedDesc: 'You can continue later from your dashboard',
        
        // Error Messages
        createFailed: 'Failed to create presence',
        tryAgain: 'Please try again'
      },
      
      // Help
      help: {
        title: 'How Can We',
        titleHighlight: 'Help You?',
        subtitle: 'Find answers, guides, and support resources',
        searchPlaceholder: 'Search help articles, guides, or topics...',
        allTopics: 'All Topics',
        gettingStarted: 'Getting Started',
        managingPresences: 'Managing Presences',
        ethicsSafety: 'Ethics & Safety',
        technical: 'Technical',
        readTime: 'min read',
        noResults: 'No results found',
        tryDifferent: 'Try different search terms or browse all topics',
        needMoreHelp: 'Need More Help?',
        contactSupport: 'Contact Support'
      },
      
      // Settings
      settings: {
        title: 'Settings',
        subtitle: 'Manage your account preferences and configurations',
        account: 'Account',
        security: 'Security',
        billing: 'Billing',
        notifications: 'Notifications',
        integrations: 'Integrations',
        dataExport: 'Data & Export'
      },
      
      // Presence Details
      presenceDetail: {
        // Overview
        loading: 'Loading...',
        simulation: 'Simulation',
        active: 'Active',
        paused: 'Paused',
        pausePresence: 'Pause',
        activatePresence: 'Activate',
        settings: 'Settings',
        
        // Metrics
        totalInteractions: 'Total Interactions',
        memoryNodes: 'Memory Nodes',
        avgResponseTime: 'Avg Response Time',
        accuracyScore: 'Accuracy Score',
        
        // Quick Actions
        quickActions: 'Quick Actions',
        startChat: 'Start Chat',
        addMemory: 'Add Memory',
        editBehavior: 'Edit Behavior',
        viewActivity: 'View Activity',
        
        // Recent Activity
        recentActivity: 'Recent Activity',
        noActivity: 'No activity yet',
        viewAllActivity: 'View All Activity',
        
        // Errors
        notFound: 'Presence not found',
        loadError: 'Failed to load presence data'
      },
      
      // Ethics Page
      ethics: {
        title: 'Ethics & Governance',
        subtitle: 'Our Principles',
        
        // Secondary Navigation
        principles: 'Core Principles',
        consent: 'Consent & Rights',
        privacy: 'Privacy & Security',
        governance: 'Governance Model',
        safety: 'Safety Controls',
        viewDetailedPages: 'View detailed pages →',
        
        // Main Title
        mainTitle: 'Built on Ethics. Powered by Consent.',
        mainSubtitle: 'RepresenX is built with respect, transparency, and user safety at its core.',
        
        // Core Principles
        principlesTitle: 'Core Principles',
        principlesSubtitle: 'The fundamental values that guide RepresenX',
        
        // Consent & Rights
        consentTitle: 'Consent & Rights',
        consentSubtitle: 'User control and presence rights',
        
        // Privacy & Security
        privacyTitle: 'Privacy & Security',
        privacySubtitle: 'How we protect your data',
        
        // Governance Model
        governanceTitle: 'Governance Model',
        governanceSubtitle: 'Rules of conduct and oversight',
        
        // Safety Controls
        safetyTitle: 'Safety Controls',
        safetySubtitle: 'Mechanisms to prevent misuse'
      },
      
      // Pricing Page
      pricing: {
        title: 'Choose the Presence That Fits Your Journey',
        
        // Plans
        basicPresence: 'Basic Presence',
        enhancedPersona: 'Enhanced Persona',
        legacyContinuum: 'Legacy Continuum',
        enterpriseIdentity: 'Enterprise Identity',
        
        perMonth: '/month',
        custom: 'Custom',
        
        // Basic Presence Features
        voiceSimulation: 'Voice simulation',
        basicStyleMapping: 'Basic style mapping',
        limitedMemoryAnchoring: 'Limited memory anchoring',
        standardPrivacyTools: 'Standard privacy tools',
        
        // Enhanced Persona Features
        fullStyleToolkit: 'Full style toolkit',
        extendedMemoryGraph: 'Extended memory graph',
        behavioralTuning: 'Behavioral tuning',
        ethicalCoreCustomization: 'Ethical core customization',
        
        // Legacy Continuum Features
        lifeStoryStructuring: 'Life story structuring',
        legacyModeDataHandling: 'Legacy mode data handling',
        multiGenerationMemory: 'Multi-generation memory',
        premiumPrivacyControls: 'Premium privacy controls',
        
        // Enterprise Identity Features
        apiAccess: 'API access',
        multiProfileSystems: 'Multi-profile systems',
        secureDeployment: 'Secure deployment',
        dedicatedSupport: 'Dedicated support & SLAs',
        
        // CTAs
        startBasic: 'Start Basic',
        upgradeToEnhanced: 'Upgrade to Enhanced',
        buildYourLegacy: 'Build Your Legacy',
        contactSales: 'Contact Sales'
      },
      
      // Features Page
      features: {
        title: 'Features That Bring Your Presence to Life',
        subtitle: 'Advanced tools that capture and express what makes you unique.',
        
        voiceSimulation: 'Voice Simulation',
        voiceSimulationDesc: 'Recreate your tone and speaking style with advanced voice modeling technology.',
        
        toneStyle: 'Tone & Style Mapping',
        toneStyleDesc: 'Define how engaging, formal, or direct your presence should be in different contexts.',
        
        memoryAnchoring: 'Memory Anchoring',
        memoryAnchoringDesc: 'Add life moments that guide contextual responses and create meaningful connections.',
        
        valueBasedResponses: 'Value-Based Responses',
        valueBasedResponsesDesc: 'Your principles form the logic of your presence, ensuring ethical alignment.',
        
        lifeStory: 'Life Story Structuring',
        lifeStoryDesc: 'Connect memories into a coherent narrative map that shapes your digital identity.',
        
        identityContinuity: 'Identity Continuity',
        identityContinuityDesc: 'Update your presence as your experiences grow, maintaining authentic evolution.',
        
        socialMediaImport: 'Learn from Social Media Data',
        socialMediaImportDesc: 'Upload your Instagram, Twitter, or Facebook archive. GPT-4 analyzes your posts to automatically create memories, interests, and Q&A examples. Quickly enrich your digital presence.',
        
        trainingModule: 'Training Center',
        trainingModuleDesc: 'Add Q&A examples, review conversations, upload bulk data, and track training metrics. Comprehensive tools to continuously improve your presence.',
        
        autoLearning: 'Auto-Learning',
        autoLearningDesc: 'GPT-4 analyzes your conversations and generates high-quality Q&A suggestions. Approve or reject — your presence gets smarter over time.'
      },
      
      // Technology Page
      technology: {
        title: 'How RepresenX Works',
        subtitle: 'A layered system that combines identity, memory, and governance.',
        description: 'RepresenX separates style, values, memories, and safety rules into distinct layers. Instead of a single black box, we use an architecture that makes every presence explainable, controllable, and respectful of consent.',
        viewArchitecture: 'View Presence Architecture',
        learnGovernance: 'Learn About Governance Layer',
        
        // 7-Layer Architecture
        architectureTitle: '7-Layer Architecture',
        architectureSubtitle: 'RepresenX architecture is divided into 7 distinct layers for clear responsibility and modular design.',
        
        personaLayer: 'Persona Layer',
        personaDesc: 'Defines your tone, style, and expression patterns.',
        
        memoryLayer: 'Memory Layer',
        memoryDesc: 'RAG system for storing context and past interactions.',
        
        chatLayer: 'Chat Layer',
        chatDesc: 'LLM integration for generating natural responses.',
        
        governanceLayer: 'Governance Layer',
        governanceDesc: 'Enforces consent boundaries and usage restrictions.',
        
        consentLayer: 'Consent Layer',
        consentDesc: 'Manages permitted actions and limitations.',
        
        accessControlLayer: 'Access Control Layer',
        accessControlDesc: 'Determines who can interact with your presence.',
        
        logsLayer: 'Logs Layer',
        logsDesc: 'Traceable behavior for transparency and accountability.'
      },
      
      // Presences List
      presences: {
        title: 'My Presences',
        subtitle: 'Manage all your digital presences from one place',
        createNew: 'Create New Presence',
        searchPlaceholder: 'Search presences by name...',
        filterAll: 'All',
        filterActive: 'Active',
        filterPaused: 'Paused',
        loading: 'Loading your presences...',
        noPresences: 'No presences yet',
        noPresencesDesc: 'Get started by creating your first digital presence',
        viewDetails: 'View Details',
        manage: 'Manage',
        delete: 'Delete',
        deleteConfirm: 'Delete Presence?',
        deleteConfirmMessage: 'This presence and all associated data (memories, conversations) will be permanently deleted. This action cannot be undone.',
        cancel: 'Cancel',
        confirmDelete: 'Yes, Delete',
        deleteSuccess: 'Presence deleted successfully',
        deleteError: 'An error occurred while deleting the presence'
      },
      
      // Presence Pages
      presence: {
        // Layout
        presencePrefix: 'RepresenX Presence',
        presenceId: 'Presence #',
        chat: 'Chat',
        activity: 'Activity',
        consent: 'Consent',
        memory: 'Memory',
        settings: 'Settings',
        training: 'Training',
        
        // ChatPage
        conversation: 'Conversation',
        liveWith: 'Live with',
        session: 'Session',
        sessionInfo: 'Session Info',
        messages: 'Messages',
        emptyChat: 'Start a conversation. The presence will respond using memories, personality, and safety filters.',
        askSomething: 'Ask something this presence would care about…',
        presenceThinking: 'Presence is thinking…',
        safeModeResponse: 'Safe mode response',
        traceability: 'Traceability',
        systemMessage: 'System message',
        somethingWentWrong: 'Something went wrong while communicating with the presence.',
        clickTraceability: 'Click the',
        clickTraceabilityLink: 'Traceability ↗',
        clickTraceabilityDesc: 'link on any response to inspect memories, personality, and governance decisions.',
        
        // TraceabilityModal
        traceabilityTitle: 'Traceability',
        responseDiagnostics: 'Response diagnostics',
        loading: 'Loading…',
        noTraceabilityRecord: 'No traceability record found.',
        inputOutput: 'Input / Output',
        userMessage: 'User message',
        response: 'Response',
        memoriesUsed: 'Memories Used',
        noMemoriesInjected: 'No memories injected.',
        governance: 'Governance',
        categoriesTriggered: 'Categories triggered',
        none: 'None',
        personaSnapshot: 'Persona snapshot',
        
        // ConsentPage
        consentLegalBasis: 'Consent & Legal Basis',
        consentDescription: 'Your explicit consent is required for your digital presence to function. By consenting, you authorize the processing of your personal data, AI model training, and allow your presence to communicate on your behalf. This consent can be withdrawn at any time.',
        loadingConsent: 'Loading consent data…',
        currentStatus: 'Current status',
        activeConsent: 'Active consent',
        withdrawn: 'Withdrawn',
        noConsent: 'None',
        acceptedAt: 'Accepted at',
        withdrawnAt: 'Withdrawn at',
        acceptConsent: 'Accept Consent',
        accepting: 'Accepting…',
        consentAccepted: 'Consent accepted!',
        consentAcceptedDesc: 'You can now chat with your presence',
        consentAcceptError: 'Failed to accept consent',
        tryAgain: 'Please try again',
        withdrawConsent: 'Withdraw Consent',
        withdrawing: 'Withdrawing…',
        latestForm: 'Latest Form',
        effectiveFrom: 'Effective from',
        
        // ActivityPage
        activitySafety: 'Activity & Safety',
        activityOverview: 'An overview of chat usage and safety events for this presence.',
        loadingActivity: 'Loading activity…',
        totalActivities: 'Total Activities (30d)',
        llmInteractions: 'LLM Interactions',
        auditEvents: 'Audit Events',
        recentEvents: 'Recent events',
        noEventsYet: 'No events yet.',
        event: 'Event',
      },
      
      // Presence List Page
      presenceList: {
        title: 'Digital Presences',
        totalCount: 'total',
        filterAll: 'All',
        filterActive: 'Active',
        filterPaused: 'Paused',
        loading: 'Loading...',
        
        // Card
        unnamed: 'Unnamed presence',
        created: 'Created',
        noDescription: 'No description provided for this presence yet.',
        
        // Status
        statusActive: 'Active',
        statusPaused: 'Paused',
        statusDeleted: 'Deleted',
        
        // Stats
        chats30d: 'Chats (30d)',
        blocked: 'Blocked',
        withMemory: 'With memory',
        chatsCount: 'chats',
        blockedCount: 'blocked',
        
        // Actions
        clickToOpen: 'Click to open workspace',
        open: 'Open',
        openWorkspace: 'Open workspace',
        
        // Quick Actions Menu
        resumePresence: 'Resume presence',
        pausePresence: 'Pause presence',
        shareAccess: 'Share access',
        settings: 'Settings',
        
        // Role & Online Status
        owner: 'Owner',
        shared: 'Shared',
        online: 'Presence is online',
        idle: 'Presence is idle',
        lastChat: 'Last chat',
        
        // Empty State
        emptyTitle: 'No presences yet.',
        emptyDesc: 'Once you create a presence, it will appear here with live usage and safety stats.',
        
        // Status Messages
        consentRequired: 'This presence is not allowed to operate until consent is accepted.',
        presencePausedMessage: 'This presence is paused. Resume it to allow new conversations.',
        noPermission: 'You don\'t have chat permission for this presence.'
      },
      
      training: {
        title: 'Presence Training Center',
        description: 'Train your presence with Q&A examples, conversation reviews, and bulk data uploads.',
        qaExamples: 'Q&A Examples',
        conversationReview: 'Conversation Review',
        bulkUpload: 'Bulk Upload',
        metrics: 'Training Metrics',
        
        addNewQA: 'Add New Q&A',
        question: 'Question',
        answer: 'Answer',
        category: 'Category',
        questionPlaceholder: 'Example: What is your favorite color?',
        answerPlaceholder: 'Example: Blue, especially navy tones.',
        
        categoryGeneral: 'General',
        categoryPersonal: 'Personal',
        categoryProfessional: 'Professional',
        categoryFamily: 'Family',
        categoryHobbies: 'Hobbies',
        
        addExample: 'Add Example',
        existingExamples: 'Existing Examples',
        loading: 'Loading...',
        noExamples: 'No examples yet. Use the form above to add your first example.',
        
        delete: 'Delete',
        confirmDelete: 'Are you sure you want to delete this example?',
        
        qaAdded: 'Q&A example added!',
        qaDeleted: 'Example deleted.',
        fillAllFields: 'Please fill all fields.',
        loadError: 'Failed to load training data.',
        addError: 'Failed to add example.',
        deleteError: 'Failed to delete example.',
        
        reviewDescription: 'Review past conversations and rate responses.',
        bulkDescription: 'Upload bulk Q&A examples in CSV or JSON format.',
        metricsDescription: 'View training progress and presence performance.',
        comingSoon: 'Coming soon...',
        
        // Review
        pendingReviews: 'Pending Reviews',
        noReviews: 'No conversations pending review.',
        userQuestion: 'User Question',
        botAnswer: 'Presence Answer',
        goodAnswer: 'Good Answer',
        correctAnswer: 'Correct',
        correctedAnswer: 'Corrected Answer',
        enterCorrectedAnswer: 'Enter the correct answer...',
        saveCorrection: 'Save Correction',
        cancel: 'Cancel',
        feedbackSaved: 'Feedback saved!',
        answerCorrected: 'Answer corrected and added to Q&A!',
        fillCorrectedAnswer: 'Please enter the corrected answer.',
        reviewsLoadError: 'Failed to load conversations.',
        feedbackError: 'Failed to save feedback.',
        correctionError: 'Failed to save correction.',
        
        // Bulk Upload
        selectFile: 'Select File',
        fileFormats: 'CSV or JSON format (max 10MB)',
        expectedFormat: 'Expected Format',
        uploadFile: 'Upload File',
        uploading: 'Uploading...',
        preview: 'Preview',
        ofTotal: 'of total',
        examplesUploaded: 'examples uploaded!',
        noFileSelected: 'Please select a file.',
        fileParseError: 'Failed to parse file. Check format.',
        uploadError: 'Upload failed.',
        
        // Metrics
        totalQA: 'Total Q&A',
        feedbackCount: 'Total Feedback',
        averageRating: 'Average Rating',
        convertedQA: 'Converted to Q&A',
        categoryBreakdown: 'Category Breakdown',
        feedbackStats: 'Feedback Statistics',
        thumbsUp: 'Positive',
        thumbsDown: 'Negative',
        noMetrics: 'No metrics yet.',
        metricsLoadError: 'Failed to load metrics.',
        
        // Additional help text
        reviewHelp: 'Review and correct presence responses',
        noReviewsDesc: 'All conversations reviewed. Wait for new chats.',
        
        // Auto-Learning Tab
        autoLearning: 'Auto-Learning',
        suggestions: 'Suggestions',
        learningSuggestions: 'Learning Suggestions',
        suggestionsDesc: 'Auto-generated Q&A suggestions from conversations',
        pendingSuggestions: 'Pending Suggestions',
        noSuggestions: 'No suggestions yet',
        noSuggestionsDesc: 'Suggestions will appear here when conversations are analyzed',
        confidence: 'Confidence',
        reason: 'Reason',
        approveSuggestion: 'Approve',
        rejectSuggestion: 'Reject',
        suggestionApproved: 'Suggestion approved and added to training data',
        suggestionRejected: 'Suggestion rejected',
        approveError: 'Approval error',
        rejectError: 'Rejection error',
        autoLearningSettings: 'Auto-Learning Settings',
        enableAutoLearning: 'Enable Auto-Learning',
        learningMode: 'Learning Mode',
        manualMode: 'Manual Review',
        autoMode: 'Auto-Approve',
        minConfidenceLevel: 'Minimum Confidence',
        autoLearningStats: 'Statistics',
        totalGenerated: 'Total Generated',
        waitingReview: 'Waiting Review',
        autoApproved: 'Auto-Approved',
        manuallyRejected: 'Manually Rejected'
      },
      
      // Memory Module
      memory: {
        knowledgeBase: 'Knowledge Base',
        addMemory: 'Add Memory',
        whatIsThis: 'What is this?',
        explanation: 'The memory system manages what your digital presence knows about you. By adding memories and facts, you make your presence more personal and realistic.',
        
        // Memory Types
        episodic: 'Episodic',
        episodicDesc: 'Life events, experiences (e.g., "I visited Paris in 2023")',
        semantic: 'Semantic',
        semanticDesc: 'Facts, preferences (e.g., "My favorite color is blue")',
        
        // Form Fields
        title: 'Title',
        description: 'Description',
        date: 'Date',
        emotion: 'Emotion',
        positive: 'Positive',
        neutral: 'Neutral',
        negative: 'Negative',
        relatedPeople: 'Related People',
        relatedPeoplePlaceholder: 'comma separated (e.g., John, Jane)',
        topic: 'Topic',
        topicPlaceholder: 'e.g., music, sports, tech',
        tags: 'Tags',
        tagsPlaceholder: 'comma separated',
        
        // Placeholders
        episodicTitlePlaceholder: 'e.g., Trip to Paris',
        semanticTitlePlaceholder: 'e.g., My favorite food',
        descriptionPlaceholder: 'Write a detailed description...',
        
        // Help Text
        episodicHelp: 'Record a specific memory or event you experienced',
        semanticHelp: 'Record a fact, preference, or piece of knowledge',
        
        // Messages
        fillRequired: 'Title and description are required',
        memoryAdded: 'Memory added successfully',
        addError: 'Error adding memory',
        saving: 'Saving...',
        save: 'Save'
      },
      
      // Audio Module
      audio: {
        recording: 'Recording',
        stopRecording: 'Stop',
        startRecording: 'Start Recording',
        listening: 'Listening...',
        microphoneError: 'Microphone access denied. Please check your browser settings.',
        transcriptionError: 'Failed to transcribe audio. Please try again.',
        playAudio: 'Play Audio',
        ttsError: 'Failed to generate audio'
      },
      
      // Footer
      footer: {
        copyright: '© Future of Representation',
        ethicsGovernance: 'Ethics & Governance',
        privacy: 'Privacy',
        terms: 'Terms',
        contact: 'Contact'
      },
      
      // Common
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        search: 'Search',
        filter: 'Filter',
        loading: 'Loading...',
        error: 'An error occurred',
        success: 'Success',
        back: 'Back',
        next: 'Next',
        finish: 'Finish',
        close: 'Close'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: undefined, // Otomatik algılama için undefined
    fallbackLng: 'tr', // Türkçe varsayılan
    interpolation: {
      escapeValue: false // React zaten XSS'den koruyor
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage']
    }
  });

export default i18n;
